<h2 class="mt-4">{{cardConfiguration.title}}</h2>
<!-- Booleans in VM are being considered string @ runtime, boolean validationsn need to be changed once they are the proper type @ runtime-->
<ng-container *ngIf="isVersion2()">
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="HasSSDiscounts">
          <span class="mandatory">*</span>{{'CardExternalPensionStatus.HasSSDiscounts' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardExternalPensionStatus.HasSSDiscounts' | translate}}"></span>
        </label>

        <div class="btn-group btn-group-toggle"  style="width:100%;">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.hasSSDiscount" [radioLabel]="hasSSDiscount">
            <input type="radio" [(ngModel)]="cardData.hasSSDiscount" #hasSSDiscount="ngModel" name="hasSSDiscount" [value]="domain.value" (ngModelChange)="ssdiscountOnChange()" required
                   [clearRelated]="(cardData.otherSocialProtectionSchemes?.toString() != 'true' && cardData.workedAbroad?.toString() != 'true')? {model : this.cardData , propsToReset : ['hasUnifiedPension','cnpPension','isPensioner','pensionsPayedByOtherEntities','pensionsValue']} : {model : this.cardData , propsToReset : ['hasUnifiedPension','cnpPension','isPensioner']}">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="BeneficiaryNumber" [class.disabled]="(certifiedData['socialSecurityData']?.socialCertification !== undefined && certifiedData['socialSecurityData']?.socialCertification === 'S') || cardData.hasSSDiscount?.toString() !== 'true'">
          <span class="mandatory" *ngIf="cardData.hasSSDiscount?.toString() === 'true' && (certifiedData['socialSecurityData'] !== undefined && certifiedData['socialSecurityData']?.socialCertification !== 'S')">*</span>{{'CardExternalPensionStatus.BeneficiaryNumber' | translate}}
        </label>
        <input class="form-control" type="text" numeric="11" [(ngModel)]="cardData.beneficiaryNumber" name="beneficiaryNumber" #beneficiaryNumber="ngModel"
               placeholder="{{'Placeholders.CardExternalPensionStatus.BeneficiaryNumber' | translate}}"
               [disabled]="(certifiedData['socialSecurityData']?.socialCertification !== undefined && certifiedData['socialSecurityData']?.socialCertification === 'S') || (cardData.hasSSDiscount?.toString() !== 'true' && ((certifiedData['socialSecurityData']?.socialCertification == undefined) || (certifiedData['socialSecurityData']?.socialCertification !== undefined && certifiedData['socialSecurityData']?.socialCertification !== 'S')))"
               [required]="cardData.hasSSDiscount?.toString() === 'true' && (certifiedData['socialSecurityData'] !== undefined && certifiedData['socialSecurityData']?.socialCertification !== 'S')">
        <validation-message [control]="beneficiaryNumber"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="SSRegisterDate" [class.disabled]="cardData.hasSSDiscount?.toString() != 'true'">
          <span class="mandatory" *ngIf="cardData.hasSSDiscount?.toString() == 'true'">*</span>
          Data de inscrição na SS
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Indique a data de inscrição na Segurança Social"></span>
        </label>
        <div class="input-group">
          <input #dpSSRegisterDate="bsDatepicker" bsDatepicker
                 type="text"
                 autocomplete="off"
                 class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [(ngModel)]="cardData.ssRegisterDate" name=" " #ssRegisterDate="ngModel"                
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [minDate]="dateOfBirthPlus12()"
                 [maxDate]="currentDate"
                 [disabled]="cardData.hasSSDiscount?.toString() != 'true'"
                 [required]="cardData.hasSSDiscount?.toString() == 'true'"
                 maxlength="10"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpSSRegisterDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpSSRegisterDate.isDisabled && dpSSRegisterDate.toggle()">
            <span class="input-group-text">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="ssRegisterDate"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="cardData.hasSSDiscount?.toString() != 'true'?'disabled':''">
          <label [ngClass]="cardData.hasSSDiscount?.toString() != 'true'?'disabled':''">
            <span class="mandatory" *ngIf="cardData.hasSSDiscount?.toString() == 'true'">*</span>
            {{'CardExternalPensionStatus.IsPensioner' | translate}}
          </label>
          <div class="btn-group btn-group-toggle"  style="width:100%;">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.isPensioner" [radioLabel]="isPensioner">
              <input type="radio" [(ngModel)]="cardData.isPensioner" #isPensioner="ngModel" name="isPensioner" [value]="domain.value" [required]="cardData.hasSSDiscount?.toString() == 'true'"
                     [clearRelated]="{model : this.cardData , propsToReset : ['hasUnifiedPension','cnpPension']} ">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="!(cardData.hasSSDiscount?.toString() === 'true' && cardData.isPensioner?.toString() === 'false')?'disabled':''">
          <label [ngClass]="!(cardData.hasSSDiscount?.toString() === 'true' && cardData.isPensioner?.toString() === 'false')?'disabled':''">
            <span class="mandatory" *ngIf="cardData.hasSSDiscount?.toString() === 'true' && cardData.isPensioner?.toString() === 'false'">*</span>
            {{'CardExternalPensionStatus.HasUnifiedPension' | translate}}
          </label>
          <div class="btn-group btn-group-toggle"  style="width:100%;">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.hasUnifiedPension" [radioLabel]="hasUnifiedPension">
              <input type="radio" [(ngModel)]="cardData.hasUnifiedPension" #hasUnifiedPension="ngModel" name="hasUnifiedPension" [value]="domain.value"
                     [clearRelated]="{model : this.cardData , propsToReset : ['cnpPension']} " [required]="cardData.hasSSDiscount?.toString() === 'true' && cardData.isPensioner?.toString() === 'false'" required>
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>
    <!-- AG:TODO :  o [required] condicional está a causar ExpressionChangedAfterItHasBeenCheckedError não é impeditivo mas tenho que ver o porquê ASAP-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="cardData.hasUnifiedPension?.toString() != 'true'?'disabled':''">
          <label [ngClass]="cardData.hasUnifiedPension?.toString() != 'true'?'disabled':''">
            <span class="mandatory" *ngIf="cardData.hasUnifiedPension?.toString() == 'true'">*</span>{{'CardExternalPensionStatus.CNPPension' | translate}}
            <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardExternalPensionStatus.CNPPension' | translate}}"></span>
          </label>
          <div class="btn-group btn-group-toggle"  style="width:100%;">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.cnpPension" [radioLabel]="cnpPension">
              <input type="radio" [(ngModel)]="cardData.cnpPension" name="cnpPension" #cnpPension="ngModel" [value]="domain.value" [required]="cardData.hasUnifiedPension?.toString() == 'true'">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="OtherSocialProtectionSchemes">
          <span class="mandatory">*</span>Descontos para outros regimes de Proteção social nacional
        </label>
        <div class="btn-group btn-group-toggle"  style="width:100%;">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.otherSocialProtectionSchemes" [radioLabel]="otherSocialProtectionSchemes">
            <input type="radio" [(ngModel)]="cardData.otherSocialProtectionSchemes" name="otherSocialProtectionSchemes" #otherSocialProtectionSchemes="ngModel" [value]="domain.value"
                   [clearRelated]="(cardData.hasSSDiscount?.toString() != 'true' && cardData.workedAbroad?.toString() != 'true')? {model : this.cardData , propsToReset : ['pensionsPayedByOtherEntities','pensionsValue']} : null" required>
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="WorkedAbroad">
          <span class="mandatory">*</span>{{'CardExternalPensionStatus.WorkedAbroad' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardExternalPensionStatus.WorkedAbroad' | translate}}"></span>
        </label>

        <div class="btn-group btn-group-toggle"  style="width:100%;">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.workedAbroad" [radioLabel]="workedAbroad">
            <input type="radio" [(ngModel)]="cardData.workedAbroad" name="workedAbroad" #workedAbroad="ngModel" [value]="domain.value" required
                   [clearRelated]="(cardData.otherSocialProtectionSchemes?.toString() != 'true' && cardData.hasSSDiscount?.toString() != 'true')? {model : this.cardData , propsToReset : ['workAbroadList','pensionsPayedByOtherEntities','pensionsValue']}: null">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>

  </div>
  <div class="col-sm-12 text-end">
    <button [disabled]="cardData.workedAbroad?.toString() == 'false' || !cardData.workedAbroad" (click)="expandNewWorkAbroad=!expandNewWorkAbroad" [ngClass]="!expandNewWorkAbroad ? '' : 'disabled'" aria-label="Nova entrada" type="button" class="btn btn-link"><span class="icon-add"></span> <span>{{'CardExternalPensionStatus.WorkedAbroadTable.AddItem' | translate}}</span></button>
  </div>

  <!--New table entry inputs-->
  <div *ngIf="expandNewWorkAbroad" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="expandNewWorkAbroad=!expandNewWorkAbroad">
      <span aria-hidden="true" class="icon-close text-primary"></span>
    </button>
    <h3 class="text-primary">{{'CardExternalPensionStatus.WorkedAbroadTable.AddItem' | translate}}</h3>
    <work-abroad-table-edit [itemList]="cardData.workAbroadList" (listChanged)="onWorkAbroadChanged($event)"></work-abroad-table-edit>
  </div>
  <table class="table table-striped">
    <thead [class.disabled]="cardData.workedAbroad?.toString() == 'false' || !cardData.workedAbroad">
      <tr>
        <th scope="col">{{'CardExternalPensionStatus.WorkedAbroadTable.Country' | translate}}</th>
        <th scope="col">{{'CardExternalPensionStatus.WorkedAbroadTable.PayedTaxes' | translate}}</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of cardData.workAbroadList; let i = index">
        <tr  *ngIf="tableItem !== null" [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          <td>{{tableItem.countryCode | commonData : countries : 'code' : 'desc'}}</td>
          <td>{{tableItem.payedTaxes | commonData : yesNo : 'value' : 'desc'}}</td>
          <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
              <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : 'text-primary icon-edit'"></span>
            </button>
            <button type="button" class="btn-icon" aria-label="Apagar">
              <span class="icon-trash p-1" (click)="removeFromList(cardData.workAbroadList, i,$event)" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
            </button>
          </td>
        </tr>
        <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
          <td class="p-0" colspan="3" id="collapseBasic">
            <div class="ml-5 mr-5 p-4">
              <work-abroad-table-edit [itemList]="cardData.workAbroadList" [editIndex]="i" (listChanged)="onWorkAbroadChanged($event)"></work-abroad-table-edit>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <!-- TODO :  Find a better way to do this both the boolean cast and the input "binding"-->
  <input hidden value="cardData.workedAbroad.length" [class.ng-invalid]="cardData.workedAbroad?.toString() == 'true' && cardData.workAbroadList.length < 1" />
  <validation-message *ngIf="cardData.workedAbroad?.toString() == 'true' && cardData.workAbroadList.length < 1" message="{{'ValidationMessages.atleastOneElement' | translate}}"></validation-message>

  <div class="row">
    <div class="col-sm-4">
      <div *ngIf="cardData.otherSocialProtectionSchemes?.toString() == 'true' || cardData.workedAbroad?.toString() == 'true' || cardData.hasSSDiscount?.toString() == 'true'" class="form-group">
        <label for="PensionsPayedByOtherEntities">
          <span class="mandatory" *ngIf="cardData.otherSocialProtectionSchemes?.toString() == 'true' || cardData.workedAbroad?.toString() == 'true' || cardData.hasSSDiscount?.toString() == 'true'">*</span>
          Pensões pagas por outras entidades
        </label>
        <div class="btn-group btn-group-toggle"  style="width:100%;">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.pensionsPayedByOtherEntities" [radioLabel]="pensionsPayedByOtherEntities">
            <input type="radio" [(ngModel)]="cardData.pensionsPayedByOtherEntities" name="pensionsPayedByOtherEntities" #pensionsPayedByOtherEntities="ngModel"
                   (ngModelChange)="pensionsPayedByOtherChanged()"
                   [required]="cardData.otherSocialProtectionSchemes?.toString() == 'true' || cardData.workedAbroad?.toString() == 'true' || cardData.hasSSDiscount?.toString() == 'true'"
                   [clearRelated]="{model : this.cardData , propsToReset : ['pensionsValue']} "
                   [value]="domain.value">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>
    <div class="col-sm-4">
      <div *ngIf="cardData.pensionsPayedByOtherEntities?.toString() == 'true'" class="form-group">
        <label for="PensionsValue">
          <span class="mandatory">*</span>
          Valor de pensões
        </label>

        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 [(ngModel)]="cardData.pensionsValue" [required]="cardData.pensionsPayedByOtherEntities?.toString() == 'true'" name="pensionsValue" #pensionsValue="ngModel" maxValue="999999,99" messageFieldType="currency">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="pensionsValue"></validation-message>
        </div>

      </div>
    </div>

  </div>
</ng-container>
<ng-container *ngIf="!isVersion2()">
  <div class="row">

    <div class="col-sm-4">
      <div class="form-group">
        <label for="HasSSDiscounts">
          <span class="mandatory">*</span>{{'CardExternalPensionStatus.HasSSDiscounts' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardExternalPensionStatus.HasSSDiscounts' | translate}}"></span>
        </label>

        <div class="btn-group btn-group-toggle"  style="width:100%;">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.hasSSDiscount" [radioLabel]="hasSSDiscount">
            <input type="radio" [(ngModel)]="cardData.hasSSDiscount" #hasSSDiscount="ngModel" name="hasSSDiscount" [value]="domain.value" required
                   [clearRelated]="{model : this.cardData , propsToReset : ['hasUnifiedPension','cnpPension','isPensioner']} ">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="BeneficiaryNumber" [class.disabled]="cardData.hasSSDiscount?.toString() != 'true'">
          <span class="mandatory" *ngIf="cardData.hasSSDiscount?.toString() == 'true'">*</span>{{'CardExternalPensionStatus.BeneficiaryNumber' | translate}}
        </label>
        <input class="form-control" type="text" numeric="11" [(ngModel)]="cardData.beneficiaryNumber" name="beneficiaryNumber" #beneficiaryNumber="ngModel"
               placeholder="{{'Placeholders.CardExternalPensionStatus.BeneficiaryNumber' | translate}}"
               [disabled]="cardData.hasSSDiscount?.toString() != 'true'"
               [required]="cardData.hasSSDiscount?.toString() == 'true'">
        <validation-message [control]="beneficiaryNumber"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="cardData.hasSSDiscount?.toString() != 'true'">
          <label for="Pensioner"><span class="mandatory" *ngIf="cardData.hasSSDiscount?.toString() == 'true'">*</span>{{'CardExternalPensionStatus.IsPensioner' | translate}}</label>
          <div class="btn-group btn-group-toggle"  style="width:100%;">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.isPensioner" [radioLabel]="isPensioner">
              <input type="radio" [(ngModel)]="cardData.isPensioner" name="isPensioner" [value]="domain.value" [required]="cardData.hasSSDiscount?.toString() == 'true'"
                     [clearRelated]="{model : this.cardData , propsToReset : ['hasUnifiedPension']} ">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>


  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="!(cardData.hasSSDiscount?.toString() == 'true' && cardData.isPensioner?.toString() == 'false')">
          <label for="HasUnifiedPension"><span class="mandatory" *ngIf="cardData.hasSSDiscount?.toString() == 'true' && cardData.isPensioner?.toString() == 'false'">*</span>{{'CardExternalPensionStatus.HasUnifiedPension' | translate}}</label>
          <div class="btn-group btn-group-toggle"  style="width:100%;">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.hasUnifiedPension" [radioLabel]="hasUnifiedPension">
              <input type="radio" [(ngModel)]="cardData.hasUnifiedPension" name="hasUnifiedPension" [value]="domain.value"
                     [clearRelated]="{model : this.cardData , propsToReset : ['cnpPension']} " [required]="cardData.hasSSDiscount?.toString() == 'true' && cardData.isPensioner?.toString() == 'false'">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>
    <!-- AG:TODO :  o [required] condicional está a causar ExpressionChangedAfterItHasBeenCheckedError não é impeditivo mas tenho que ver o porquê ASAP-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="cardData.hasUnifiedPension?.toString() != 'true'">
          <label for="CNPPension">
            <span class="mandatory" *ngIf="cardData.hasUnifiedPension?.toString() == 'true'">*</span>{{'CardExternalPensionStatus.CNPPension' | translate}}
            <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardExternalPensionStatus.CNPPension' | translate}}"></span>
          </label>
          <div class="btn-group btn-group-toggle"  style="width:100%;">
            <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.cnpPension" [radioLabel]="cnpPension">
              <input type="radio" [(ngModel)]="cardData.cnpPension" name="cnpPension" #cnpPension="ngModel" [value]="domain.value" [required]="cardData.hasUnifiedPension?.toString() == 'true'">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

  </div>

  <div class="row">
    <div class="col-sm-6">
      <h2 class="mt-4">{{'CardExternalPensionStatus.WorkedAbroadTable.Title' | translate}}</h2>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="WorkedAbroad">
          <span class="mandatory">*</span>{{'CardExternalPensionStatus.WorkedAbroad' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardExternalPensionStatus.WorkedAbroad' | translate}}"></span>
        </label>

        <div class="btn-group btn-group-toggle"  style="width:100%;">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.workedAbroad" [radioLabel]="workedAbroad">
            <input type="radio" [(ngModel)]="cardData.workedAbroad" name="workedAbroad" #workedAbroad="ngModel" [value]="domain.value" required
                   [clearRelated]="{model : this.cardData , propsToReset : ['workAbroadList']} ">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </div>
    </div>

  </div>
  <div class="col-sm-12 text-end">
    <button [disabled]="cardData.workedAbroad?.toString() == 'false' || !cardData.workedAbroad" (click)="expandNewWorkAbroad=!expandNewWorkAbroad" [ngClass]="!expandNewWorkAbroad ? '' : 'disabled'" aria-label="Nova entrada" type="button" class="btn btn-link"><span class="icon-add"></span> <span>{{'CardExternalPensionStatus.WorkedAbroadTable.AddItem' | translate}}</span></button>
  </div>

  <!--New table entry inputs-->
  <div *ngIf="expandNewWorkAbroad" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="expandNewWorkAbroad=!expandNewWorkAbroad">
      <span aria-hidden="true" class="icon-close text-primary"></span>
    </button>
    <h3 class="text-primary">{{'CardExternalPensionStatus.WorkedAbroadTable.AddItem' | translate}}</h3>
    <work-abroad-table-edit [itemList]="cardData.workAbroadList" (listChanged)="onWorkAbroadChanged($event)"></work-abroad-table-edit>
  </div>
  <table class="table table-striped">
    <thead [class.disabled]="cardData.workedAbroad?.toString() == 'false' || !cardData.workedAbroad">
      <tr>
        <th scope="col">{{'CardExternalPensionStatus.WorkedAbroadTable.Country' | translate}}</th>
        <th scope="col">{{'CardExternalPensionStatus.WorkedAbroadTable.PayedTaxes' | translate}}</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of cardData.workAbroadList; let i = index">
        <tr  [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
          <td>{{tableItem.countryCode | commonData : countries : 'code' : 'desc'}}</td>
          <td>{{tableItem.payedTaxes | commonData : yesNo : 'value' : 'desc'}}</td>
          <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
            <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
              <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : 'text-primary icon-edit'"></span>
            </button>
            <button type="button" class="btn-icon" aria-label="Apagar">
              <span class="icon-trash p-1" (click)="removeFromList(cardData.workAbroadList, i,$event)" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
            </button>
          </td>
        </tr>
        <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
          <td class="p-0" colspan="3" id="collapseBasic">
            <div class="ml-5 mr-5 p-4">
              <work-abroad-table-edit [itemList]="cardData.workAbroadList" [editIndex]="i" (listChanged)="onWorkAbroadChanged($event)"></work-abroad-table-edit>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <!-- TODO :  Find a better way to do this both the boolean cast and the input "binding"-->
  <input hidden value="cardData.workedAbroad.length" [class.ng-invalid]="cardData.workedAbroad?.toString() == 'true' && cardData.workAbroadList.length < 1" />
  <validation-message *ngIf="cardData.workedAbroad?.toString() == 'true' && cardData.workAbroadList.length < 1" message="{{'ValidationMessages.atleastOneElement' | translate}}"></validation-message>

</ng-container>
  <!--<pre>{{cardData | json}}</pre>-->
